// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"542e8806","228":"2fb33f05","268":"3844f584","471":"e04ed8fe","474":"8b88d1cf"}[chunkId] + ".chunk.css";
};